import React, {useEffect, useState} from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "components/base-components/base-paragraph";
import illustration from "components/../assets/png/logo_Hellobank_xerius.png"
import illustration1 from "components/../assets/svg/group59Copy.svg"
import BaseButton from "components/base-components/base-button";
import StepsWrapper from "steps/steps-wrapper";
import StepsLoader from "steps/steps-loader";
import Fade from "@material-ui/core/Fade";
import InputField from "../../base-components/base-input";
import { useHistory } from "react-router-dom";
import { BASE_URL } from '../../../env';
import deleteCookie from '../../../functions/deleteCookie';
import { AppDataContext } from '../../../contexts/app-data';



const TextBody = () =>(
    <>
    <h3> {t('pro_infos.pro_info_xerius.title')}</h3>
    <p>{t('pro_infos.pro_info_xerius.text1')}</p>
    <ul>
        <li>{t('pro_infos.pro_info_xerius.list.1')}</li>
        <li>{t('pro_infos.pro_info_xerius.list.2')}</li>
        <li>{t('pro_infos.pro_info_xerius.list.3')}</li>
    </ul>
        <h3> {t('pro_infos.pro_info_xerius.title2')}</h3>
    <p>{t('pro_infos.pro_info_xerius.text2')}</p>

    </>
)

const XeriusConsent = () => {
  const lang = localStorage.getItem('language')
    const { state, dispatch } = React.useContext(AppDataContext)

  const history = useHistory();
  const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`
  const confidential_link = lang === "FR" ? "https://www.xerius.be/fr-be/footer/informations-juridiques" : "https://www.xerius.be/nl-be/footer/juridische-informatie"
  // const loadingMessage = t('general.loading_message')

  const [isLoading, setIsLoading] = useState(true)
  const [endLoading, setEndLoading] = useState(false)
  const [inputData, setInputData] = useState({})
  const [isValid, setIsValid] = useState(false)
  const [nextStick, setNextStick] = useState(false)
  const [loadingMessage, setLoadingMessage] = useState("")

  const fetch_init_options = {
    method: 'POST',
    credentials: 'include',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',            
    }
  }
  const fetch_POST_Xerius_consent = {
      ...fetch_init_options,
      body: JSON.stringify(
          [{
          fieldId: "xerius_consent_flag",
          fieldValue: "1"
          }]
      )
  }

  useEffect(() => {
    const loaderTimeout = 900
    const oneHourTimeout = 1000 * 60 * 60

    const time1 = setTimeout(() => {
      setIsLoading(false)
      setLoadingMessage( () => 
        <>
          <p>{t('pro_infos.pro_info_popup_data_sent.text')}</p>
          <p>{t('general.loading_message')}</p>
        </>
       )
    }, loaderTimeout);

    setEndLoading(true)

    const time2 = setTimeout(function () {
      deleteCookie()
    }, oneHourTimeout); //one hour


   if (window.PageBus) {
      window.PageBus.publish("analyticsServices", {
          pageID: "onboarding",
          stepSeq: "3",
          stepName: "pro info:xerius consent",
          flowType: "sales",
          flowName: "onboarding",
          productName: "onboarding",
          trackMethod: "flow"
        }
        );
    }

    
      return function cleanup() {
        setEndLoading(false)
        clearTimeout(time1)
        clearTimeout(time2)
        };
  }, [])

  useEffect(() => {
    if (nextStick) sendActivation()
  }, [nextStick])

  const getInputValue = (name, value) => {
      console.log(name, value)
      setInputData({
            ...inputData,
            [name] : value
      })
    // if(name === "xerius_consent" && value === 1) fetch(`${base_URL}`, fetch_POST_Xerius_consent)
    setIsValid(value === 1)
  }

  const sendActivation = () => {
    fetch(`${base_URL}/activation/ACTXE1`, fetch_init_options).catch( error => {
      console.log("error : "+ error)
    }).then(res => {
      return res.json()
    }).then(res => {
      console.log(res)
      const xerius = res.filter(a => a.component === "XERIUS")
      console.log("xerius => ", xerius[0].status)
      console.log("xerius => ", xerius[0].message)
      if (xerius[0].status === "OK") {
        window.location.href = xerius[0].message
      } else {
        history.push(`/${lang.toLowerCase()}/confirmation?xerius=error`)
      }
    })
  }

  const action = () => {
    setIsLoading(true)
    // fetch(`${base_URL}`, fetch_POST_Xerius_consent).then(() => {
      setNextStick(true)
    // })
  }
    return (
      <div className={"pre-confirmation"}>
        <StepsWrapper stepGroupTitle={t('general.register_your_enterprise')} title={t('general.open_pro_account') }  loaded={0.1}>
          <StepsLoader loading={isLoading} loadingMessage={loadingMessage}>
            <Fade in={endLoading} timeout={{ enter: 300, exit: 1200 }} >
              <div>
                  <BaseParagraph illustration={illustration} />
                  <BaseParagraph   >
                    <p>
                      {t('pro_infos.pro_info_xerius_consent.text')}
                    </p>
                    <InputField
                      checkboxLabel={t('pro_infos.pro_info_xerius_consent.opt_in')}
                      type={"checkbox"}
                      value={inputData["xerius_consent"]}
                      name={"xerius_consent"}
                      id={"xerius_consent"}
                      getInputValue={getInputValue}
                    />
                    <br />
                    <a href={confidential_link} target="_blank" rel="noreferrer">{t('pro_infos.pro_info_xerius_consent.link')}</a>
                  </BaseParagraph>

            <div className={"footer-action"} style={{bottom: state.footer_height}}>
            <BaseButton caption={t('general.continue')} action={action} disabled={ !isValid }/>
            </div>
          </div>
          </Fade>
          </StepsLoader>
          </StepsWrapper>
        </div>

    )
}

XeriusConsent.propTypes = {
    name: PropTypes.string
}

XeriusConsent.defaultProps = {
    name: "Step02"
}


export default XeriusConsent